import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/localization/feature1.png';
import _imports_1 from './img/localization/feature2.png';
import _imports_2 from './img/localization/feature3.png';
import _imports_3 from './img/localization/feature4.png';
import _imports_4 from './img/localization/feature5.png';
import _imports_5 from './img/localization/feature6.png';
import _imports_6 from './img/localization/worth1.png';
import _imports_7 from './img/localization/worth2.png';
import _imports_8 from './img/localization/worth3.png';
import _imports_9 from './img/localization/worth4.png';
import _imports_10 from './img/localization/worth5.png';
import _imports_11 from './img/localization/superiority1.png';
import _imports_12 from './img/localization/superiority2.png';
import _imports_13 from './img/localization/superiority3.png';
import _imports_14 from './img/localization/superiority4.png';
import _imports_15 from './img/localization/superiority5.png';
import _imports_16 from './img/barleyWeb.png';
import _imports_17 from './img/wisdom.png';
import _imports_18 from './img/IEnglish.png';
const _hoisted_1 = {
  class: "solution-case"
};
const _hoisted_2 = {
  class: "solution-case-banner"
};
const _hoisted_3 = {
  class: "case-info"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "desc"
};
const _hoisted_6 = {
  class: "feature-box"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "feature-lists"
};
const _hoisted_9 = {
  class: "feature-item"
};
const _hoisted_10 = {
  class: "feature-title"
};
const _hoisted_11 = {
  class: "feature-desc"
};
const _hoisted_12 = {
  class: "feature-item"
};
const _hoisted_13 = {
  class: "feature-title"
};
const _hoisted_14 = {
  class: "feature-desc"
};
const _hoisted_15 = {
  class: "feature-item"
};
const _hoisted_16 = {
  class: "feature-title"
};
const _hoisted_17 = {
  class: "feature-desc"
};
const _hoisted_18 = {
  class: "feature-item"
};
const _hoisted_19 = {
  class: "feature-title"
};
const _hoisted_20 = {
  class: "feature-desc"
};
const _hoisted_21 = {
  class: "feature-item"
};
const _hoisted_22 = {
  class: "feature-title"
};
const _hoisted_23 = {
  class: "feature-desc"
};
const _hoisted_24 = {
  class: "feature-item"
};
const _hoisted_25 = {
  class: "feature-title"
};
const _hoisted_26 = {
  class: "feature-desc"
};
const _hoisted_27 = {
  class: "worth-box"
};
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = {
  class: "worth-content"
};
const _hoisted_30 = {
  class: "worth-item"
};
const _hoisted_31 = {
  class: "worth-info"
};
const _hoisted_32 = {
  class: "sub-title"
};
const _hoisted_33 = {
  class: "sub-desc"
};
const _hoisted_34 = {
  class: "worth-item"
};
const _hoisted_35 = {
  class: "worth-info"
};
const _hoisted_36 = {
  class: "sub-title"
};
const _hoisted_37 = {
  class: "sub-desc"
};
const _hoisted_38 = {
  class: "worth-item"
};
const _hoisted_39 = {
  class: "worth-info"
};
const _hoisted_40 = {
  class: "sub-title"
};
const _hoisted_41 = {
  class: "sub-desc"
};
const _hoisted_42 = {
  class: "worth-item"
};
const _hoisted_43 = {
  class: "worth-info"
};
const _hoisted_44 = {
  class: "sub-title"
};
const _hoisted_45 = {
  class: "sub-desc"
};
const _hoisted_46 = {
  class: "worth-item"
};
const _hoisted_47 = {
  class: "worth-info"
};
const _hoisted_48 = {
  class: "sub-title"
};
const _hoisted_49 = {
  class: "sub-desc"
};
const _hoisted_50 = {
  class: "superiority-box"
};
const _hoisted_51 = {
  class: "title"
};
const _hoisted_52 = {
  class: "superiority-content"
};
const _hoisted_53 = {
  class: "superiority-item"
};
const _hoisted_54 = {
  class: "superiority-info"
};
const _hoisted_55 = {
  class: "superiority-title"
};
const _hoisted_56 = {
  class: "superiority-desc"
};
const _hoisted_57 = {
  class: "superiority-item"
};
const _hoisted_58 = {
  class: "superiority-info"
};
const _hoisted_59 = {
  class: "superiority-title"
};
const _hoisted_60 = {
  class: "superiority-desc"
};
const _hoisted_61 = {
  class: "superiority-item"
};
const _hoisted_62 = {
  class: "superiority-info"
};
const _hoisted_63 = {
  class: "superiority-title"
};
const _hoisted_64 = {
  class: "superiority-desc"
};
const _hoisted_65 = {
  class: "superiority-item"
};
const _hoisted_66 = {
  class: "superiority-info"
};
const _hoisted_67 = {
  class: "superiority-title"
};
const _hoisted_68 = {
  class: "superiority-desc"
};
const _hoisted_69 = {
  class: "superiority-item"
};
const _hoisted_70 = {
  class: "superiority-info"
};
const _hoisted_71 = {
  class: "superiority-title"
};
const _hoisted_72 = {
  class: "superiority-desc"
};
const _hoisted_73 = {
  class: "more-case"
};
const _hoisted_74 = {
  class: "case-title"
};
const _hoisted_75 = {
  class: "desc"
};
const _hoisted_76 = {
  class: "more-case-box"
};
const _hoisted_77 = {
  class: "case-info"
};
const _hoisted_78 = {
  class: "tag"
};
const _hoisted_79 = {
  class: "tag"
};
const _hoisted_80 = {
  class: "tag"
};
const _hoisted_81 = {
  class: "tag"
};
const _hoisted_82 = {
  class: "title"
};
const _hoisted_83 = {
  class: "case-desc"
};
const _hoisted_84 = {
  class: "link-txt"
};
const _hoisted_85 = {
  class: "case-info"
};
const _hoisted_86 = {
  class: "tag"
};
const _hoisted_87 = {
  class: "tag"
};
const _hoisted_88 = {
  class: "tag"
};
const _hoisted_89 = {
  class: "tag"
};
const _hoisted_90 = {
  class: "title"
};
const _hoisted_91 = {
  class: "case-desc"
};
const _hoisted_92 = {
  class: "link-txt"
};
const _hoisted_93 = {
  class: "case-info"
};
const _hoisted_94 = {
  class: "tag"
};
const _hoisted_95 = {
  class: "tag"
};
const _hoisted_96 = {
  class: "tag"
};
const _hoisted_97 = {
  class: "tag"
};
const _hoisted_98 = {
  class: "title"
};
const _hoisted_99 = {
  class: "case-desc"
};
const _hoisted_100 = {
  class: "link-txt"
};
const _hoisted_101 = {
  class: "bottom-banner"
};
const _hoisted_102 = {
  class: "banner-con"
};
const _hoisted_103 = {
  class: "banner-content"
};
const _hoisted_104 = {
  class: "title"
};
const _hoisted_105 = {
  class: "desc"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'localization',
  setup(__props) {
    const router = useRouter();
    const advisoryServiceRef = ref(null);
    const goAdvisory = () => {
      advisoryServiceRef['value'].show();
    };
    const toCasePage = path => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      router.push(`/successCase/${path}`);
    };
    return (_ctx, _cache) => {
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('localization.text1')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('localization.text2')), 1), _createElementVNode("div", {
        class: "doc-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('localization.text3')), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('localization.text4')), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_0
      }, null, -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('localization.text5')), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('localization.text6')), 1)]), _createElementVNode("div", _hoisted_12, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_1
      }, null, -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('localization.text7')), 1), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('localization.text8')), 1)]), _createElementVNode("div", _hoisted_15, [_cache[5] || (_cache[5] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_2
      }, null, -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('localization.text9')), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('localization.text10')), 1)]), _createElementVNode("div", _hoisted_18, [_cache[6] || (_cache[6] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_3
      }, null, -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('localization.text11')), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('localization.text12')), 1)]), _createElementVNode("div", _hoisted_21, [_cache[7] || (_cache[7] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_4
      }, null, -1)), _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('localization.text13')), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('localization.text14')), 1)]), _createElementVNode("div", _hoisted_24, [_cache[8] || (_cache[8] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_5
      }, null, -1)), _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('localization.text15')), 1), _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('localization.text16')), 1)])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t('localization.text17')), 1), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_cache[9] || (_cache[9] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_6
      }, null, -1)), _createElementVNode("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('localization.text18')), 1), _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('localization.text19')), 1)])]), _createElementVNode("div", _hoisted_34, [_cache[10] || (_cache[10] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_7
      }, null, -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('localization.text20')), 1), _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('localization.text21')), 1)])]), _createElementVNode("div", _hoisted_38, [_cache[11] || (_cache[11] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_8
      }, null, -1)), _createElementVNode("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('localization.text22')), 1), _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('localization.text23')), 1)])]), _createElementVNode("div", _hoisted_42, [_cache[12] || (_cache[12] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_9
      }, null, -1)), _createElementVNode("div", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('localization.text24')), 1), _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('localization.text25')), 1)])]), _createElementVNode("div", _hoisted_46, [_cache[13] || (_cache[13] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_10
      }, null, -1)), _createElementVNode("div", _hoisted_47, [_createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('localization.text26')), 1), _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('localization.text27')), 1)])])])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("h3", _hoisted_51, _toDisplayString(_ctx.$t('localization.text28')), 1), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_cache[14] || (_cache[14] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_11
      }, null, -1)), _createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('localization.text29')), 1), _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('localization.text30')), 1)])]), _createElementVNode("div", _hoisted_57, [_cache[15] || (_cache[15] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_12
      }, null, -1)), _createElementVNode("div", _hoisted_58, [_createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('localization.text31')), 1), _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('localization.text32')), 1)])]), _createElementVNode("div", _hoisted_61, [_cache[16] || (_cache[16] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_13
      }, null, -1)), _createElementVNode("div", _hoisted_62, [_createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('localization.text33')), 1), _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('localization.text34')), 1)])]), _createElementVNode("div", _hoisted_65, [_cache[17] || (_cache[17] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_14
      }, null, -1)), _createElementVNode("div", _hoisted_66, [_createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('localization.text35')), 1), _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('localization.text36')), 1)])]), _createElementVNode("div", _hoisted_69, [_cache[18] || (_cache[18] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_15
      }, null, -1)), _createElementVNode("div", _hoisted_70, [_createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t('localization.text37')), 1), _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('localization.text38')), 1)])]), _cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "superiority-item",
        style: {
          "opacity": "0"
        }
      }, null, -1))])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("h3", _hoisted_74, _toDisplayString(_ctx.$t('successCase.text181')), 1), _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t('successCase.text182')), 1), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", {
        class: "case-item",
        onClick: _cache[0] || (_cache[0] = $event => toCasePage('barleyWeb'))
      }, [_cache[20] || (_cache[20] = _createElementVNode("img", {
        class: "case-img",
        src: _imports_16
      }, null, -1)), _createElementVNode("div", _hoisted_77, [_createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('successCase.text37')), 1), _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.$t('successCase.text38')), 1), _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t('successCase.text39')), 1), _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('successCase.text40')), 1), _createElementVNode("h4", _hoisted_82, _toDisplayString(_ctx.$t('successCase.text36')), 1), _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.$t('successCase.text41')) + "......", 1), _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.$t('successCase.text183')) + " >", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[1] || (_cache[1] = $event => toCasePage('wisdom'))
      }, [_cache[21] || (_cache[21] = _createElementVNode("img", {
        class: "case-img",
        src: _imports_17
      }, null, -1)), _createElementVNode("div", _hoisted_85, [_createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t('successCase.text50')), 1), _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.$t('successCase.text38')), 1), _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$t('successCase.text57')), 1), _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t('successCase.text58')), 1), _createElementVNode("h4", _hoisted_90, _toDisplayString(_ctx.$t('successCase.text560')), 1), _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$t('successCase.text59')) + "......", 1), _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.$t('successCase.text183')) + " >", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[2] || (_cache[2] = $event => toCasePage('IEnglish'))
      }, [_cache[22] || (_cache[22] = _createElementVNode("img", {
        class: "case-img",
        src: _imports_18
      }, null, -1)), _createElementVNode("div", _hoisted_93, [_createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.$t('successCase.text37')), 1), _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.$t('successCase.text38')), 1), _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t('successCase.text43')), 1), _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t('successCase.text40')), 1), _createElementVNode("h4", _hoisted_98, _toDisplayString(_ctx.$t('successCase.text42')), 1), _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.$t('successCase.text44')) + "......", 1), _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.$t('successCase.text183')) + " >", 1)])])])]), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createElementVNode("h3", _hoisted_104, _toDisplayString(_ctx.$t('localization.text39')), 1), _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$t('localization.text40')), 1), _createElementVNode("span", {
        class: "consult-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('localization.text3')), 1)])])]), _createVNode(_component_AdvisoryService, {
        ref_key: "advisoryServiceRef",
        ref: advisoryServiceRef
      }, null, 512)]);
    };
  }
});